<!-- AnnouncementMedia.vue -->
<template>
  <swiper-container class="flex w-full h-[70vh]" :slidesPerView="1" :loop="true" :modules="modules" :autoplay="{
    delay: 2000,
    pauseOnMouseEnter: true,
  }" :speed="1200" ref="swiperRefPromotionalBanner">
    <swiper-slide v-for="(item, index) in images" :key="index">
      <img class="w-full h-screen object-cover" :src="item" alt="Announcement Image" />
    </swiper-slide>
  </swiper-container>
</template>

<script>
import { Navigation } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css/pagination";
export default {
  props: ['images'],

  data() {
    return {
      imageIndex: 0,
      modules: [Navigation],
    };
  },

}
</script>